/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const apiValidationWorkflowsUpdateBodyNameMax = 256;

export const apiValidationWorkflowsUpdateBodyDescriptionMax = 1024;

export const ApiValidationWorkflowsUpdateBody = zod.strictObject({
    name: zod.string().min(1).max(apiValidationWorkflowsUpdateBodyNameMax),
    description: zod
        .string()
        .max(apiValidationWorkflowsUpdateBodyDescriptionMax)
        .optional(),
    forms: zod.array(zod.number()).optional(),
});

export type ApiValidationWorkflowsUpdateBody = zod.input<
    typeof ApiValidationWorkflowsUpdateBody
>;
export type ApiValidationWorkflowsUpdateBodyOutput = zod.output<
    typeof ApiValidationWorkflowsUpdateBody
>;
